import React from 'react';
import { UserPlus, HelpCircle } from 'react-feather';

function HouseholdWagesGrid({ formData, onDataChange }) { 
  const tooltipText = "Wages paid to a household employee (nanny, housekeeper) if you did NOT withhold taxes.";

  return (
    <div className="form-section">
      <div className="content-box-header">
        <div className="header-title-with-help">
          <h2><UserPlus size={20} className="icon-orange" /> Household Employee Wages</h2>
          <div className="has-tooltip header-help-icon" data-tooltip={tooltipText}>
            <HelpCircle size={18} />
          </div>
        </div>
      </div>

      <div className="dependent-card">
        <div className="form-group">
          <label style={{ fontWeight: 600, color: '#553e33ff' }}>Total Wages Paid</label>
          <p style={{ fontSize: '0.9rem', color: '#8b7464ff', marginBottom: '0.75rem' }}>
            Enter the total amount paid to household employees.
          </p>
          <div className="input-with-prefix">
            <span className="prefix">$</span>
            <input 
              type="number" 
              name="manualHouseholdWages" 
              value={formData?.manualHouseholdWages ?? ''} 
              onChange={onDataChange} 
              placeholder="0" 
            />
          </div>
        </div>

        <div className="form-group" style={{ marginTop: '1.5rem', paddingTop: '1.5rem', borderTop: '1px dashed #f0e9e2ff' }}>
          <div className="header-title-with-help" style={{ marginBottom: '0.5rem' }}>
            <label style={{ fontWeight: 600, color: '#553e33ff' }}>Household Employment Taxes</label>
            <div className="has-tooltip header-help-icon" data-tooltip="If you paid cash wages of $2,700+ to a household employee, enter the calculated tax here.">
              <HelpCircle size={16} />
            </div>
          </div>
          <div className="input-with-prefix">
            <span className="prefix">$</span>
            <input 
              type="number" 
              name="householdEmploymentTax" 
              value={formData?.householdEmploymentTax ?? ''} 
              onChange={onDataChange} 
              placeholder="0" 
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default HouseholdWagesGrid;